const en_US = {
  cancel: 'Cancel',
  confirm: 'Confirm',
  please_open_in_imtoken: 'Please open in imToken',
  update_app_title: 'Update imToken to latest version',
  update_app_desc: 'Current imToken doesn\'t work with this dapp. Please visit https://token.im via system browser and download the latest version',
  no_wallet_title: 'No wallets found',
  no_wallet_desc: 'Please check',
  understood: 'Understood',
  energy: 'Energy',
  bandwidth: 'Bandwidth',
  freeze: 'Freeze',
  unfreeze: 'UnFreeze',
  resource: 'Resource',
  self: 'Me',
  others: 'Others',
  receiver: 'Receiver',
  receiver_address: 'Receiver address',
  freeze_amount: 'Freeze Amount',
  resource_type: 'Resource Type',
  please_enter_freeze_amount: 'Please enter freeze amount',
  invalid_freeze_amount: 'Invalid freeze amount',
  invalid_receiver: 'Invalid receiver provided',
  freeze_amount_less_than_1: 'Freeze amount cannot less than 1 TRX',
  can_more_than_6_decimal: 'Amount must less than 6 decimals',
  not_time_to_unfreeze: 'Not time to unfreeze',
  packing: 'transction confirming...',
  freeze_success: 'Freeze Success',
  unfreeze_success: 'Unfreeze Success',
  how_freeze_and_unfreeze: 'How to freeze and unfreeze',
  unfreeze_after_3_days: 'Note: Unfreeze is available after 3 days',
  wait_time_to_unfreeze: 'Note: Unfreeze is available until $s',
  unfreezeable: 'To Be Unfreezed',
  freeze_migration_tip: 'Due to the upgrade of the Tron network to Stake 2.0, the freezing service is temporarily suspended. Please go to the official DApp to carry out the freezing operation.',
  unfreeze_v1_staked_trx: 'Unfreeze TRX in V1 Staking',
  link_justlend_desc: 'Official Energy Lease Service',
  link_feeeio_desc: 'Save 70% Miner Fee',
  link_resource_management_desc: 'Manage TRON Resources on DAppso',
  title_rent_resource: 'Rent Resource',
}

export default en_US
